import $context from "@/app-context";

export default {
  log
}

export function log (location = { name: "unknown" }, params = { }, modes = ["hide"]) {
  if ($context.developing) {
    if (modes.includes("hide")) {
      console.groupCollapsed(location.name);
    } else {
      console.group(location.name)
    }
    console.time(location.name);
    console.log(new Date);
    console.log(location);
    if (modes.includes("temp")) {
      console.clear(); // [WIP]
    }
    if (params.data) {
      console.log(params.data);
    }
    console.timeEnd(location.name);
    console.groupEnd();
  }
}
